// Auth guard (RequireAuth)
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { BASE_URL } from "shared/lib/config";

// Safe URL joiner: avoids // or missing /
const join = (a, b) =>
	`${String(a || "").replace(/\/+$/, "")}/${String(b || "").replace(/^\/+/, "")}`;

export default function RequireAuth({ roles }) {
	const [status, setStatus] = useState("loading"); // 'loading' | 'ok' | 'fail' | 'forbidden'
	const [profile, setProfile] = useState(null);
	const loc = useLocation();

	useEffect(() => {
		const auth = getAuth();

		const unsub = onAuthStateChanged(auth, async (user) => {
			if (!user) {
				sessionStorage.removeItem("idToken");
				localStorage.removeItem("idToken");
				setStatus("fail");
				return;
			}

			try {
				const token = await user.getIdToken();
				const url = BASE_URL ? join(BASE_URL, "/api/auth/me") : "/api/auth/me";

				const res = await fetch(url, {
					headers: { Authorization: `Bearer ${token}` },
				});

				if (res.status === 401) {
					sessionStorage.removeItem("idToken");
					localStorage.removeItem("idToken");
					setStatus("fail");
					return;
				}
				if (!res.ok) {
					setStatus("fail");
					return;
				}

				const me = await res.json();
				setProfile(me);

				if (Array.isArray(roles) && roles.length && !roles.includes(me.role)) {
					setStatus("forbidden");
				} else {
					setStatus("ok");
				}
			} catch (err) {
				console.error("[RequireAuth] /api/auth/me failed:", err);
				setStatus("fail");
			}
		});
		return () => unsub();
	}, [roles]);

	if (status === "loading") return null;
	if (status === "fail") return <Navigate to="/" replace state={{ from: loc }} />;
	if (status === "forbidden") return <Navigate to="/report" replace />;
	return <Outlet context={{ profile }} />;
}
